import { useState } from "react";

import { Namespace, useT } from "@racoon/i18n";
import { IcCancel } from "@racoon/icons";
import { Button, Input, Sheet, SheetContent, Separator } from "@racoon/ui";
import { ArrowUp } from "lucide-react";

export const ChatActions = ({
  input,
  onInputChange,
  onSend,
  loading,
}: {
  input: string;
  onInputChange: (value: string) => void;
  onSend: (value?: string) => void;
  loading: boolean;
}) => {
  const t = useT();

  const [isSheetOpen, setIsSheetOpen] = useState(false);

  return (
    <div className="flex justify-between items-center gap-4 px-4 lg:px-0">
      <div className="flex flex-1 items-center gap-2">
        {/* <div>
          <Button
            id="chat-actions-send-button"
            className="!w-8 !h-8 rounded-[200px] flex items-center justify-center !p-0"
            variant={"opacityBlueWithoutOutline"}
            onClick={() => setIsSheetOpen(true)}
            disabled={loading}
          >
            <IcMenu className="w-6 h-6" />
          </Button>
        </div> */}
        <Input
          id="chat-actions-input"
          className="lg:!bg-white !bg-[#F2F4F7] rounded-[100px] border-none !h-8"
          placeholder={t(Namespace.Chat, "askQuestion")}
          value={input}
          onChange={(e) => onInputChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !loading) onSend();
          }}
          disabled={loading}
        />
        <div>
          <Button
            id="chat-actions-send-button"
            className="!w-8 !h-8 rounded-[200px] flex items-center justify-center !p-0"
            onClick={() => onSend()}
            disabled={loading || !input}
          >
            <ArrowUp className="w-4 h-4" />
          </Button>
        </div>
      </div>

      <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
        <SheetContent
          side="bottom"
          className="p-0 w-full rounded-t-2xl bg-white border border-gray-200"
          aria-describedby={undefined}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-4 w-full">
            <h3 className="text-base font-semibold">Часто задаваемые запросы</h3>
            <IcCancel onClick={() => setIsSheetOpen(false)} className="w-8 h-8 text-gray-900" />
          </div>

          {/* Separator */}
          <Separator className="w-full" />

          {/* Prompts List */}
          <div className="flex flex-col p-2 w-full">
            {["Промпт 1", "Промпт 2", "Промпт 3", "Промпт 4", "Промпт 5"].map((prompt, index) => (
              <div
                onClick={() => {
                  onSend(prompt);
                  setIsSheetOpen(false);
                }}
                key={index}
                className="text-sm p-2 font-normal truncate cursor-pointer hover:bg-gray-100 transition-colors text-left rounded"
              >
                {prompt}
              </div>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};
